import { authFetch } from '../utils/api';

const userService = {
    // Récupérer la liste des utilisateurs du groupe
    getUsersList: async (tokenOverride) => { 
        // Utilisation de .get() au lieu de l'appel direct
        const response = await authFetch.get('/users/list', {}, tokenOverride); 
        return response.json(); // Le nouvel authFetch renvoie la réponse brute de fetch
    },

    getAllPersons: async () => {
        const response = await authFetch.get(`/persons/${localStorage.getItem('user_id')}`);
        return response.json();
    },

    getAllAccounts: async () => {
        const response = await authFetch.get(`/all-accounts/${localStorage.getItem('user_id')}`);
        return response.json();
    },

    inviteUser: async (email, role, sharedPersonIds, sharedAccountIds, accessLevel) => { 
        const response = await authFetch.post('/users/invite', { 
            email, role, sharedPersonIds, sharedAccountIds, accessLevel 
        });
        return response.json();
    },

    updateGroupUser: async (id, data) => {
        const response = await authFetch.put(`/users/update-group/${id}`, data);
        return response.json();
    },

    removeGroupUser: async (id) => {
        const response = await authFetch.delete(`/users/remove-from-group/${id}`);
        return response.json();
    },
    
    setAccountPermission: async (accountId, sharedWithUserId, accessLevel, isActive = true) => {
         const response = await authFetch.post('/permissions/account', {
             account_id: accountId, 
             shared_with_user_id: sharedWithUserId, 
             access_level: accessLevel, 
             is_active: isActive 
         });
         return response.json();
    },

    setPersonPermission: async (personId, sharedWithUserId, accessLevel, isActive = true) => {
         const response = await authFetch.post('/permissions/person', {
             person_id: personId, 
             shared_with_user_id: sharedWithUserId, 
             access_level: accessLevel, 
             is_active: isActive 
         });
         return response.json();
    },
};

export default userService;